var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1889_4512)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49812 0C2.91478 0 0 2.91559 0 6.49994C0 7.92145 0.458424 9.23976 1.23771 10.3098L0.427806 12.7248L2.9262 11.9263C3.95379 12.6065 5.18007 13 6.50188 13C10.0852 13 13 10.0843 13 6.50006C13 2.91571 10.0852 0.000107447 6.50188 0.000107447L6.49812 0ZM4.68348 3.30168C4.55744 2.99982 4.46192 2.98839 4.27098 2.98063C4.20597 2.97686 4.13352 2.97308 4.05319 2.97308C3.80479 2.97308 3.54506 3.04566 3.38841 3.20614C3.19747 3.40101 2.72372 3.85569 2.72372 4.78812C2.72372 5.72055 3.40372 6.62235 3.49536 6.74853C3.59088 6.87449 4.82105 8.81571 6.73109 9.60686C8.22476 10.2259 8.668 10.1685 9.00794 10.0959C9.50453 9.98896 10.1273 9.62196 10.2839 9.17883C10.4406 8.73547 10.4406 8.35715 10.3947 8.27691C10.3488 8.19668 10.2227 8.15095 10.0317 8.05529C9.8408 7.95974 8.91241 7.50118 8.73667 7.44003C8.56471 7.37511 8.40051 7.39808 8.2707 7.58152C8.08731 7.83755 7.9078 8.09746 7.76257 8.25405C7.64796 8.37635 7.46068 8.39166 7.30414 8.32663C7.094 8.23884 6.50577 8.03232 5.77986 7.38654C5.21825 6.88603 4.83626 6.26322 4.72553 6.076C4.6147 5.88501 4.71409 5.77404 4.80185 5.67094C4.89738 5.55241 4.98903 5.4684 5.08456 5.35754C5.18008 5.24678 5.23356 5.18941 5.29469 5.05945C5.3597 4.93338 5.31376 4.80343 5.26794 4.70788C5.22212 4.61233 4.84013 3.6799 4.68348 3.30168Z",
    fill: "#67C15E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1889_4512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.64e9808ad7c00b1124618390751a23b8.svg";
export { ForwardRef as ReactComponent };